import { formatDate } from '@src/corelib/utils/formatUtils';

/**
 * Presentational helpers for the Stripe-provider StatusCard (M34). Kept as a
 * plain no-JSX module so they are unit-testable in the project's node-env Vitest
 * (no jsdom) without mounting React — mirroring how `BillingPaymentModal`
 * extracted `submitBillingPayment`. Both reuse the shared `formatDate`
 * ("Jun 3, 2026") so the renewal/cancel dates match the invoice table.
 */

// Stripe returns lowercase brand keys ("visa", "mastercard", …). Map the common
// ones to their display casing; anything unmapped gets a first-letter capitalize.
const BRAND_LABELS = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'Amex',
  discover: 'Discover',
  diners: 'Diners Club',
  jcb: 'JCB',
  unionpay: 'UnionPay',
};


/** Card-on-file line, e.g. "•••• 4242 · Visa". Returns null when no card. */
export function formatCardLine(card) {
  if (!card || !card.last4) {
    return null;
  }
  const brand = card.brand || '';
  const label = BRAND_LABELS[brand.toLowerCase()]
    || (brand ? `${brand[0].toUpperCase()}${brand.slice(1)}` : 'Card');
  return `•••• ${card.last4} · ${label}`;
}


/** "Cancels on {date}" banner text when the subscription is set to cancel at
 * period end, else null. */
export function cancelNotice(subscription) {
  if (!subscription || !subscription.cancel_at_period_end) {
    return null;
  }
  return `Cancels on ${formatDate(subscription.current_period_end, { withYear: true })}`;
}


/** "Renews {date}" line for an active subscription that is NOT scheduled to
 * cancel, else null. */
export function renewalNotice(subscription) {
  if (!subscription || subscription.cancel_at_period_end || !subscription.current_period_end) {
    return null;
  }
  return `Renews ${formatDate(subscription.current_period_end, { withYear: true })}`;
}
